import React from 'react';
import Model from './Model';
import Project from './Project'
import Document from './Document'
import UserDiscipline from './UserDiscipline'
import IsolatedScroll from "react-isolated-scroll";

import HasRequiredExperience from './decorators/HasRequiredExperience'
import HasMatching from "./decorators/HasMatching";
import Auth from "../Auth";
import User from "./User";
import TalentCandidate from "./TalentCandidate";


const ChangeOrders = {
    TypeTimeline: 'Timeline',
    TypeRate: 'Rate',
    TypeCandidate: 'Candidate'
}

export default class ProjectPosition extends HasMatching(HasRequiredExperience(Model))
{
    static Key = 'ProjectPosition';

    static ChangeOrderTypes = ChangeOrders;

    transformForUpdate() {
        let updateFields = [
            "id", "title", "description", "description_file","description_path",
            "required_onsite", "onsite_days_per_week",
            "started_at", "ended_at", "avg_hours_per_period", "target_rate", "max_rate",
            "target_rate_is_visible", "is_contract_to_hire",
            "wants_intermediate_experience", "wants_senior_experience", "wants_junior_experience",
            "disciplines", "skills", "industries", "tags", "templates",
            'actual_total_periods',
            'payout_frequency',
            'payout_amount',
            "brands",
            "deliverables",
            "budget",

        ];
        let auth = TB.auth()?.user();
        if(auth.canManageClients?.()) {
            updateFields.push(
                'client_tax_preference',
                'listing_status',
                'percent_markup',
                'is_talent_hourly_breakdown_required',
                'is_talent_payout_auto_confirmed'
            )
        }

        let transformed = TB.pick(this, updateFields);

        //Remove total hours from deliverables
        if (transformed.deliverables?.length) {
            transformed.deliverables = TB.map(transformed.deliverables, deliverable => {
                return {
                    ...deliverable,
                    total_hours: deliverable.total_hours || undefined,
                }
            })
        }

        if (typeof transformed.description_file === 'string' ||
            (this.description_document && this.description_document?.path === transformed.description_file?.path)
        ) {
            delete transformed.description_file;
            delete transformed.description_path;
        }else if (!transformed.description_file && this.description_document) {
            transformed.description_path = false;
        }else if(transformed.description_path) {
            delete transformed.description_path;
        }

        let numberInputs = [
            'onsite_days_per_week',
            'avg_hours_per_period',
            'target_rate',
            'max_rate',
            'budget'
            // 'actual_total_periods',
        ]

        numberInputs.map(prop => {
            if(transformed[prop] && !TB.isNaN(Number(transformed[prop]))) {
                transformed[prop]= Number(transformed[prop]);
            }
        });

        let booleanInputs = [
            'target_rate_is_visible',
            'required_onsite',
            'is_contract_to_hire',
            'wants_junior_experience',
            'wants_intermediate_experience',
            'wants_senior_experience',
        ]
        booleanInputs.map(prop => {
            transformed[prop] = transformed[prop] ? 1 : 0
        })

        return transformed;
    }

    static normalize(props) {
        if (props.started_at) {
            props.started_at = new Date(props.started_at)
        }
        if (props.ended_at) {
            props.ended_at = new Date(props.ended_at)
        }

        if (props.skills?.length && (TB.filter(props.skills, skill => !TB.isDefined(skill.importance))).length > 0) {
            props.skills = TB.map(props.skills, skill => {
                skill.importance = 1;
                return skill;
            })
        }

        if (props.candidate_options?.length) {
            props.has_candidates = !!TB.find(
                props.candidate_options, {is_candidate: true}
            );
        }
        if (!props.industries) {
            props.industries = []
        }

        if (TB.isObject(props.description_document) && !props.description_file) {
            props.description_file = Document.make(props.description_document)
        }

        if (props.disciplines) {
            props.disciplines = UserDiscipline.makeMany([...props.disciplines])
        }

        props.original_total_periods = props.actual_total_periods;
        props.original_platform_rate = props.platform_rate;
        props.original_ended_at = props.ended_at;
        props.original_percent_markup = props.percent_markup;

        // props.original_contract_value = props.platform_cost;
        // props.original_talent_cost = props.standard_platform_cost;

        if (props.assigned_candidate) {
            let job_candidate = props.assigned_candidate?.job_candidate;
            props.original_rate = job_candidate?.hourly_rate;
        }
        if (props.change_order_items?.length) {
            // Map through desc to get accurate original total hours
            // let timelineFilters = TB.filter(props.change_orders, ['type', ChangeOrders.TypeTimeline]);
            // timelineFilters = TB.orderBy(timelineFilters, 'created_at', 'desc');
            // //
            let original_total_periods = props.actual_total_periods;
            // let original_contract_value = props.original_contract_value || 0;
            // let original_talent_cost = props.original_talent_cost || 0;
            //
            // TB.map(timelineFilters, changeOrder => {
            //     if (changeOrder.type === ChangeOrders.TypeTimeline) {
            //         original_total_periods -= changeOrder.affected_periods;
            //     }
            // });


            // Map through asc to get correct contract values
            let change_orders = TB.orderBy(props.change_order_items, 'id', 'desc');
            props.change_order_items = TB.map(change_orders, item => {
                // if (item.type === ChangeOrders.TypeTimeline) {
                //
                // }

                props.original_rate = item.original_rate;
                props.original_platform_rate = item.original_platform_rate;
                props.original_ended_at = item.original_ended_at;
                props.original_percent_markup = item.original_percent_markup;
                props.original_total_periods = item.original_total_periods;
                props.original_contract_value = item.original_contract_value;
                props.original_percent_markup = item.original_percent_markup;
                props.original_talent_cost = item.original_talent_cost;
                if (!item.id) {
                    return item;
                }
                return {
                    ...item,
                    total_periods: item.new_total_periods,
                    platform_cost: item.new_contract_value,
                    contract_value: item.new_contract_value,
                    talent_cost: item.new_talent_cost,
                    ended_at: item.new_ended_at,
                    rate: item.new_rate,
                    platform_rate: item.new_platform_rate,
                    percent_markup: item.new_percent_markup,
                };
            })

            let lastChangeOrder = TB.last(change_orders);
            // props.original_total_periods = lastChangeOrder.original_total_periods;
            // props.original_platform_rate = lastChangeOrder.original_platform_rate;
            // props.original_rate = lastChangeOrder.original_rate;
            // props.hourly_rate = lastChangeOrder.new_rate;
            // props.original_ended_at = lastChangeOrder.original_ended_at;
            // props.original_percent_markup = lastChangeOrder.original_percent_markup;
            // let original_rate = null;

            // props.change_orders = TB.map(change_orders, changeOrder => {
            //     if (changeOrder.original_rate) {
            //         original_rate = changeOrder.original_rate;
            //     }
            //     if (!props.original_rate) {
            //         props.original_rate = original_rate;
            //     }
            //
            //     let order = {
            //         ...changeOrder,
            //         original_contract_value,
            //         original_talent_cost,
            //         original_total_periods,
            //         original_rate
            //     }
            //
            //     if (changeOrder.type === ChangeOrders.TypeTimeline) {
            //         original_total_periods += changeOrder.affected_periods;
            //     }
            //     original_contract_value += changeOrder.net_contract_value;
            //     original_talent_cost += changeOrder.net_talent_cost;
            //
            //     if (changeOrder.new_rate) {
            //         original_rate = changeOrder.new_rate;
            //     }
            //     return {
            //         ...order,
            //         new_total_periods: original_total_periods,
            //         new_contract_value: original_contract_value,
            //         new_talent_cost: original_talent_cost,
            //         new_rate: original_rate
            //     }
            // })
        }

        if (props.actual_total_periods) {
            props.actual_total_periods = parseFloat(props.actual_total_periods)
        }
        if (props.actual_total_hours) {
            props.actual_total_hours = parseFloat(props.actual_total_hours)
        }
        if (props.exact_platform_rate) {
            props.exact_platform_rate = parseFloat(props.exact_platform_rate)
        }
        if (props.payout_amount) {
            props.payout_amount = parseFloat(props.payout_amount)
        }

        if (props.deliverables?.length) {
            props.deliverables = TB.orderBy(props.deliverables, del => del.target_delivery_at ? TB.moment(del.target_delivery_at).valueOf() : 0, 'asc')
        }

        if (!props.exact_platform_cost && props.budget) {
            props.exact_platform_cost = props.budget;
        }
        if (!props.exact_premarkup_cost && props.budget) {
            props.exact_premarkup_cost = props.budget / (1 +(props.percent_markup || 0));
        }
        if (TB.auth()?.user?.()?.canManageClients?.() && props.percent_markup) {
            props.display_percent_markup = Number((parseFloat((props.percent_markup)) * 100).toFixed(4));
        }
        return props;
    }

    static getSuggestionValue(suggestion) {
        return suggestion.name;
    }

    static renderSuggestion(suggestion, {query, isHighlighted}) {

        // console.log("RENDER SUGGESTION", skill, query);
        // let searched = String(skill.name).split(new RegExp( query, "gi"));
        // console.log("searchedddd", searched);

        return (
            <p className={"suggestion skill-suggestion " + (isHighlighted && "highlighted-suggestion")}>
                {suggestion.isCustom ? (
                    <span>
                            {suggestion.isUnique ? (
                                <span>
                                    No matching skills found. Press enter to add <span
                                    className={"custom-name"}>{suggestion.name}</span>
                                </span>
                            ) : (
                                <span className={"text-italic"}>
                                    Add custom skill <span className={"custom-name"}>{suggestion.name}</span>
                                </span>
                            )}
                    </span>
                ) : suggestion.name}

                {isHighlighted && (!suggestion.isCustom || !suggestion.isUnique) && (
                    <span className="suggestion-help">
                        Press enter to select
                    </span>
                )}
            </p>
        );
    }

    static renderSectionTitle(category) {
        return (
            <strong>{category.name}</strong>
        );
    }

    static getSectionSuggestions(category) {
        return category.skills;
    }

    static shouldRenderSuggestions(value) {
        return value.trim().length >= 1;
    }

    static renderSuggestionsContainer({containerProps, children}, isDisabled) {
        const {ref, ...restContainerProps} = containerProps;
        const callRef = isolatedScroll => {
            if (isolatedScroll !== null) {
                ref(isolatedScroll.component);
            }
        };

        if (!restContainerProps.className) {
            restContainerProps.className = "suggest";
        }
        if (isDisabled) restContainerProps.className += " suggestions-disabled";

        return (
            <IsolatedScroll ref={callRef} {...restContainerProps}>
                {children}
            </IsolatedScroll>
        );
    }

    static async runProjectRequest(project, requestProp, requestMethod, appendToUrl = '') {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }

        project = Project.make({...project});

        this[requestProp] = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${project.id}/positions/${appendToUrl}`)
        );

        let response = await this[requestProp][requestMethod]().catch(console.warn);

        if (!response
            || !response.success
            || !response.success.data) {
            this[requestProp].didHandleError = await this[requestProp].handleError();
            if (this[requestProp].didHandleError
                && this[requestProp].shouldRerun) {
                return this.runProjectRequest(
                    project, requestProp, requestMethod, appendToUrl
                );
            }

            return;
        }

        return response.success.data;
    }

    async requestCandidateProposals(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'SendCandidateProposalsRequest', 'post', `${this.id}/request-proposals`
        );

        if (!responseData) {
            return;
        }

        this.proposals_requested_at = TB.moment();
        this.refreshInProjectCacheFor(project);

        return this;
    }

    async cancelRequestCandidateProposals(project) {
        let responseData = await this.constructor.runProjectRequest(
            project, 'CancelCandidateProposalsRequest', 'post', `${this.id}/request-proposals/cancel`
        );

        if (!responseData) {
            return;
        }

        this.proposals_requested_at = undefined;
        this.refreshInProjectCacheFor(project);

        return this;
    }

    totalCandidates() {
        return TB.find(
            this.candidate_options, {is_candidate: true}
        );
    }

    refreshInProjectCacheFor(project) {
        let updatedPosition = {...this};

        let positions = TB.map([...project.positions], position => {
            if (position.id === updatedPosition.id) {
                return updatedPosition;
            }
            return position;
        })


        let updatedProject = Project.make({...project, positions});
        if (updatedProject.isBYO() && updatedProject.isSelectingTalent() && updatedProject.canRequestProposal()) {
            updatedProject.status = 'Accepting Proposals';
        }
        if (updatedProject.isBYO() && updatedProject.isAcceptingProposals() && !updatedProject.canRequestProposal()) {
            updatedProject.status = 'Selecting Talent';
        }

        return Project.refreshCacheFor(updatedProject);
    }

    calculatedTotalHours() {
        const weeks = this.calculatedTotalWeeks() || 1;
        if (!weeks || !this.avg_hours_per_period) {
            return
        }
        return weeks * this.avg_hours_per_period
    }

    calculatedTotalWeeks = TB.memoize(this.calcWeeks.bind(this));
    calcWeeks() {
        if (!TB.moment(this.started_at).isValid() || !TB.moment(this.ended_at).isValid()) {
            return;
        }

        let calcWeeks = 0
        try {
            let firstMonday = TB.moment(this.started_at).isoWeekday() === 1 ?
                TB.moment(this.started_at).startOf('isoweek') :
                TB.moment(this.started_at).add(1,'week').startOf('isoweek');

            let lastMonday = TB.moment(this.ended_at).endOf('isoWeek');


            calcWeeks = Math.round(lastMonday.diff(firstMonday, 'weeks', true));

            if (calcWeeks < 0) calcWeeks = 0;

        }catch (e) {
            console.warn('ERROR: calcHours', e)
        }
        return calcWeeks
    }

    relatedProject = TB.memoize(this.getRelatedProject.bind(this));

    getRelatedProject() {
        if (this.project_id) {
            return TB.queryClient.getQueryData(['fetchProject', this.project_id]);
        }
        let projects = TB.queryClient.getQueriesData({
            predicate: ({queryKey}) => queryKey?.[0] === 'fetchProject'
        });

        return TB.find(projects, project => TB.find(project.positions, ['id', this.id]))
    }

    contractTypeName() {
        return Project.contractTypeNameFor(this.contract_type || this.relatedProject()?.contract_type || this.project?.contract_type) || Project.ContractType.TimeMaterials;
    }

    isFixedRetainer() {
        return this.contractTypeName() === Project.ContractType.FixedRetainer;
    }

    fixedRetainerBudgetType() {
        return this.contractTypeName() === Project.ContractType.FixedRetainer && (
            this.isFixedRetainerRateBased() ? 'rateBased' : (this.isFixedRetainerCostPerPeriodBased() ? 'costPerPeriodBased' : undefined)
        );
    }

    isFixedRetainerRateBased() {
        return parseInt(this.target_rate) >= 0
    }

    isFixedRetainerCostPerPeriodBased() {
        return !this.isFixedRetainerRateBased()
    }

    isFixedFee() {
        return this.contractTypeName() === Project.ContractType.FixedFee
    }

    isTimeMaterials() {
        return this.contractTypeName() === Project.ContractType.TimeMaterials
    }

    /**
     * Whether the role was edited in a way that changes what its candidate
     * scoring criteria should be. Flagged by the API on save.
     */
    criteriaNeedRefresh() {
        return !!this.criteria_needs_refresh;
    }

    /**
     * Ask whether to rebuild the scoring criteria and re-assess the candidates
     * who have already proposed, then act on the answer.
     *
     * Returns true when a refresh was queued.
     */
    async confirmCriteriaRefresh(project) {
        if (!this.criteriaNeedRefresh()) {
            return false;
        }

        let shouldRefresh = await TB.alert('warning', 'Refresh Candidate Scoring?',
            "The changes you made affect what this role's candidates are scored on. Rebuild the scoring criteria and re-assess every candidate who has already submitted a proposal? Their current criteria ratings and fit scores will be replaced.",
            [
                {title: 'Yes, refresh scoring'},
                {title: 'Not now'}
            ]
        );

        let responseData = await this.constructor.runProjectRequest(
            project, 'RefreshCriteriaRequest', 'post',
            `${this.id}/criteria/${shouldRefresh ? 'refresh' : 'dismiss-refresh'}`
        );

        if (!responseData) {
            return false;
        }

        this.criteria_needs_refresh = false;
        this.refreshInProjectCacheFor(project);

        if (shouldRefresh) {
            TB.toast("Candidate scoring is being refreshed");
        }

        return !!shouldRefresh;
    }

    async checkIfPricingAffectsCurrentCandidates(updates = {}) {
        if (this.isTimeMaterials()) {
            return true;
        }
        let fieldsToCheck = [];
        if (this.isFixedFee()) {

        }
        if (this.isFixedRetainer()) {
            fieldsToCheck = [
                'payout_amount',
                'payout_frequency',
                'budget',
                'actual_total_periods',
                'target_rate',
                'avg_hours_per_period',
                'actual_total_periods',
            ];
        }

        let current = TB.pick(this, fieldsToCheck);
        let difference = TB.pick(updates, fieldsToCheck);

        if (!TB.isEqual(difference, current) && (this.interested_candidates_count > 0 || this.total_selected_candidates > 0)) {

            let confirmedChanges = await TB.alert('warning', 'This Will Affect Existing Proposals',
                // "Modifying pricing terms will reset the proposal process for this role. All current candidate submissions will need to be updated and resubmitted. Candidates will receive notification about the new requirements. Proceed with changes?",
                "Modifying pricing terms will require current candidates to update their existing pricing proposal based upon the new requirements. All current candidates will receive a notification to make updates and you will see their pricing as 'pending' until a new price has been submitted. Proceed with changes?",
                [
                    {title: 'Yes, continue'},
                    {title: 'Cancel'}
                ]
            );
            return confirmedChanges;
        }
        return true;
    }

    recommendedHours() {
        let estimated = parseInt(this.estimated_total_periods);

        return Math.round(estimated + (estimated * 0.10))
    }

    hasSetTitle() {
        return TB.isString(this.title)
            && this.title.length > 0;
    }

    hasSetDates() {
        if (this.isFixedRetainer()) {
            return !!this.started_at && TB.moment(this.started_at).isValid()
        }
        return !!this.started_at &&
            !!this.ended_at &&
            TB.moment(this.started_at).isValid() &&
            TB.moment(this.ended_at).isValid() &&
            TB.moment(this.started_at).isBefore(this.ended_at, 'day')
    }

    hasSetAvgDaysPerWeek() {
        return !!this.avg_hours_per_period && parseInt(this.avg_hours_per_period) > 0
    }

    hasSetRequiredOnSite() {
        return !this.required_onsite || TB.inRange(parseInt(this.onsite_days_per_week), 1, 8)
    }

    hasSetTerms() {
        if (!this.hasSetTitle() || !this.hasSetDates()) {
            return false;
        }
        let contractType = Project.contractTypeNameFor(this.contract_type || this.relatedProject()?.contract_type);

        if (!contractType) {
            return true;
        }

        switch (contractType) {
            default:
            case Project.ContractType.TimeMaterials:
                return this.hasSetAvgDaysPerWeek() && this.hasSetRequiredOnSite()
            case Project.ContractType.FixedFee:
                return !TB.isNaN(parseInt(this.budget)) && this.deliverables?.length > 0
            case Project.ContractType.FixedRetainer:

                if (this.isFixedRetainerRateBased()) {
                    return !TB.isNaN(parseInt(this.target_rate)) && this.avg_hours_per_period > 0 && (this.payout_frequency === 'weekly' ? (this.avg_hours_per_period <= 40) :
                        (this.payout_frequency === 'monthly' && this.avg_hours_per_period <= 500)
                    ) && this.actual_total_periods > 0
                }
                if (this.isFixedRetainerCostPerPeriodBased()) {
                    return !TB.isNaN(parseInt(this.budget)) && this.actual_total_periods > 0
                }
                return false;
        }
    }

    hasSelectedExperience() {
        return this.wants_intermediate_experience
            || this.wants_senior_experience
            || this.wants_junior_experience
    }

    needsSetup() {
        return !this.hasSetTitle()
            || !this.hasSetTerms()
            || !this.templates?.length
            || !this.disciplines?.length
            || (this.isHiringSourceWizard() && !this.skills?.length)
            // || !this.industries?.length;

            || (this.isHiringSourceWizard() && !this.hasSelectedExperience())
    }

    hasIncompleteSteps() {
        return this.currentRequiredStep() !== false
    }

    currentRequiredStep() {
        if (!this.hasSetTitle()) return 'title';
        if (!this.templates?.length) return 'wripple-roles';
        if (!this.hasSetTerms()) return 'timing-and-budget';

        if (this.isHiringSourceWizard() && !this.skills?.length) return 'skills';
        // if (!this.industries?.length) return 'industry-experience';
        if (this.isHiringSourceWizard() && !this.hasSelectedExperience()) return 'job-specification';

        return false;
    }

    steps() {
        return [
            'Title', 'Wripple Roles', 'Timing & Budget', 'Skills', 'Industry Experience', 'Brands','Job Specification'
        ]
    }
    stepRoutes() {
        return TB.map(this.steps(), step => TB.toLower(TB.slugify(step)))
    }
    isAppropriateStep(step) {

        let routes = this.stepRoutes();

        if (!this.currentRequiredStep()) {
            console.log('isAppropriateStep', step)
            return true
        }
        if (this.currentRequiredStep() && !step) {
            console.log('isAppropriateStep', step)
            return false;
        }
        if (this.currentRequiredStep() === step) {
            console.log('isAppropriateStep', step)
            return true
        }
        if(!routes.includes(step)) {
            console.log('isAppropriateStep', routes)
            return false;
        }

        return routes.indexOf(step) <= routes.indexOf(this.currentRequiredStep())
    }

    calculateFixedRetainerBudgetPerPeriod() {
        if (this.isFixedRetainerRateBased()) {
            return parseFloat(Number(this.target_rate * this.avg_hours_per_period).toFixed(2));
        }


        if (!this.budget || !this.actual_total_periods) {
            return false
        }

        return parseFloat(this.budget)
    }

    calculateFixedRetainerBudget() {
        if (this.isFixedRetainerRateBased()) {
            return parseFloat(Number(this.target_rate * this.avg_hours_per_period).toFixed(2)) * parseFloat(this.actual_total_periods);
        }


        if (!this.budget || !this.actual_total_periods) {
            return false
        }

        return parseFloat(Number(this.budget * parseFloat(this.actual_total_periods)).toFixed(2))
    }

    payoutFrequency(frequency = this.payout_frequency,periods = this.actual_total_periods) {
        return TB.pluralize(frequency === 'weekly' ? 'week' : (frequency === 'monthly') ? 'month' : '',periods,false)
    }
    payoutFrequencyLabel(frequency = this.payout_frequency,periods = this.actual_total_periods) {
        return TB.pluralize(frequency === 'weekly' ? 'week' : (frequency === 'monthly') ? 'month' : '',periods,true)
    }

    calculateFixedRetainedEstimatedEndDate(started_at = this.started_at, frequency = this.payout_frequency,periods = this.actual_total_periods)  {
        if (!started_at || !frequency || !periods) {
            return null;
        }
        const addBusinessTime = (startDate, amount, frequency) => {

            if (!TB.moment(startDate).isValid()) return false;

            let date = TB.moment(startDate);

            switch (frequency.toLowerCase()) {
                case 'week':
                case 'weeks':
                    // Use 5-day work week, skip weekends
                    const businessDaysToAdd = Math.ceil(amount * 5);
                    let daysAdded = 0;

                    while (daysAdded < businessDaysToAdd) {
                        date.add(1, 'day');
                        if (date.day() !== 0 && date.day() !== 6) {  // Skip weekends
                            daysAdded++;
                        }
                    }
                    break;

                case 'month':
                case 'months':
                    // Use 30 calendar days average (includes weekends)
                    const calendarDaysToAdd = Math.ceil(amount * 30);
                    date.add(calendarDaysToAdd, 'days');
                    break;

                // case 'day':
                // case 'days':
                //     // Business days (skip weekends)
                //     const daysToAdd = Math.ceil(amount);
                //     let businessDaysAdded = 0;
                //
                //     while (businessDaysAdded < daysToAdd) {
                //         date.add(1, 'day');
                //         if (date.day() !== 0 && date.day() !== 6) {
                //             businessDaysAdded++;
                //         }
                //     }
                //     break;

                default:
                    return false;
            }

            return date;
        }
        let duration = frequency === 'weekly' ? 'week' : (frequency === 'monthly') ? 'month' : null
        return addBusinessTime(started_at, periods, duration)?.toDate?.()

        // let estimatedStart = TB.moment(started_at);
        // let duration = frequency === 'weekly' ? 'week' : (frequency === 'monthly') ? 'month' : null
        // return estimatedStart.add(periods, duration || 'week').toDate()
    }
    calculateBudgetBasedOnStrategy() {
        if (this.isFixedRetainer()) {
            return this.calculateFixedRetainerBudget();
        }

        return this.budget;
    }
    hasFixedFeePricingStrategy() {
        return this.fixedFeePricingStrategyIsFullBreakdown()
            || this.fixedFeePricingStrategyIsTotalPayout()
        || this.fixedFeePricingStrategyIsPayoutByDeliverable()
    }

    getFixedFeePricingStrategyName = (strategy = this.fixedFeePricingStrategyValue()) => {
        switch (strategy) {
            case "total-payout":
                return "Total Project Payout";
            case "per-deliverable":
                return "Payout Per Deliverable";
            case "hourly-rate":
                return "Payout Per Deliverable Based Upon Hours/Rate";
            default:
                return "Not Set";
        }
    };

    setFixedFeePricingStrategy(value) {

        switch (value) {
            case 'hourly-rate':
                this.is_talent_hourly_breakdown_required = true;
                this.payout_amount = null;
                this.deliverables = TB.map([...(this.deliverables || [])], del => {
                    del.payout_amount = null;
                    return del;
                });
                break;
            case 'total-payout':
                this.is_talent_hourly_breakdown_required = false;
                let payout = 0;
                this.deliverables = TB.map([...(this.deliverables || [])], del => {
                    if (del.payout_amount && del.is_active) {
                        // payout += 0;//parseFloat(del.payout_amount);
                    }
                    del.payout_amount = null;
                    return del;
                });
                this.payout_amount = this.estimatedFixedFeeTalentPayoutByBudget();

                break;
            case 'per-deliverable':
                this.is_talent_hourly_breakdown_required = false;
                let totalPayout = this.payout_amount || parseFloat(this.budget);
                let activeDeliverables = TB.filter(this?.deliverables || [], ['is_active', true]);

                let payoutPerDeliverable = totalPayout > 0 ?
                    Math.floor(totalPayout / activeDeliverables.length) : 0;

                this.deliverables = TB.map([...(this.deliverables || [])], del => {
                    del.payout_amount = 0;//del.is_active ? payoutPerDeliverable : 0;
                    return del;
                });
                this.payout_amount = null;

                break;
        }
        return this;
    }

    estimatedFixedFeeTalentPayoutByBudget(rounded = false) {
        let payout = this.budget / (1 +(this.percent_markup || 0));

        if (rounded) {
            return Math.round(payout / 100) * 100
        }
        return Math.round(payout)
    }

    fixedFeePricingStrategyValue() {
        if (this.fixedFeePricingStrategyIsFullBreakdown()) {
            return 'hourly-rate'
        }
        if (this.fixedFeePricingStrategyIsTotalPayout()) {
            return 'total-payout'
        }
        if (this.fixedFeePricingStrategyIsPayoutByDeliverable()) {
            return 'per-deliverable'
        }
        return false;
    }

    fixedFeePricingStrategyIsFullBreakdown() {
        return this.isFixedFee() && this.is_talent_hourly_breakdown_required
    }

    fixedFeePricingStrategyIsTotalPayout() {
        return this.isFixedFee() && !this.fixedFeePricingStrategyIsFullBreakdown() && TB.isDefined(this.payout_amount) && this.payout_amount !== null
    }

    fixedFeePricingStrategyIsPayoutByDeliverable() {
        return this.isFixedFee() && !this.fixedFeePricingStrategyIsFullBreakdown() &&
            !this.fixedFeePricingStrategyIsTotalPayout() &&
            TB.find(this.deliverables, del => TB.isDefined(del.payout_amount) && del.payout_amount !== null)
    }

    getTotalTalentPayoutByStrategy() {

        let activeDeliverables = TB.filter(this?.deliverables || [], ['is_active', true]);

        if (this.fixedFeePricingStrategyIsFullBreakdown()) {
            let totalHours;
            let defaultTotalHours = TB.sumBy(activeDeliverables, 'total_hours');
            if (this.assigned_candidate) {
                totalHours = this.assigned_candidate?.job_candidate?.total_hours || defaultTotalHours;
            }else {
                totalHours = defaultTotalHours;
            }
            let defaultTalentCost = (this.exact_standard_platform_rate / (1 + (this.percent_markup || 0))) * totalHours;
            if (this.assigned_candidate) {
                return this.assigned_candidate.job_candidate?.exact_premarkup_cost || defaultTalentCost;
            }
            return defaultTalentCost
        }
        if (this.fixedFeePricingStrategyIsTotalPayout()) {
            return this.payout_amount || parseFloat(this.budget) || 0
        }
        if (this.fixedFeePricingStrategyIsPayoutByDeliverable()) {
            return TB.sumBy(activeDeliverables, del => parseFloat(del.payout_amount || 0))
        }
    }

    hasValidFixedFeeDeliverables() {
        if (!this.hasFixedFeePricingStrategy()) {
            return false;
        }


        if (this.fixedFeePricingStrategyIsTotalPayout()) {
            return parseFloat(this.payout_amount) > 0
        }
        let activeDeliverables = this.activeDeliverables();

        if (this.fixedFeePricingStrategyIsPayoutByDeliverable()) {
            return !TB.find(activeDeliverables, del => !del.payout_amount)
        }
        if (this.fixedFeePricingStrategyIsFullBreakdown()) {
            return !TB.find(activeDeliverables, del => !del.total_hours)
        }

        return false
    }

    canConfirmScope = () => {
        let missingDeliverables = TB.filter(this.disciplines, ['talent_opp', undefined])
        // if (missingDisciplines?.length > 0) {
        //     return false
        // }
        // let missingDeliverableHours = TB.find(TB.flatMap(this?.phases, 'deliverables'), del => del?.total_team_hours <= 0);
        //
        // return missingDeliverableHours?.length <= 0;
        return true;
    }

    canEditCandidateScope() {
        return !this.statusIsRejected() && !this.statusIsWithdrawn() && !this.statusIsApproved()
    }
    canAcceptPayout = () => {
        if (!this.hasConfirmedScope()) {
            return false;
        }

        return this.canEditCandidateScope()
    }

    taxClassification() {
        if (this.assigned_candidate.employed_by === 'Wripple') {
            return this.assigned_candidate.employed_by
        }
        let taxClassLookup = _.keyBy(laravel.greenlight_tax_class_preferences, 'key');
        return this.assigned_candidate && !!this.assigned_candidate.client_tax_preference && taxClassLookup[this.assigned_candidate.client_tax_preference]?.label
    }

    candidateTaxClass() {

        if ((this.assigned_candidate.employed_by === 'Wripple' && !this.assigned_candidate?.tax_class)
            || this.assigned_candidate?.tax_class === 'Independent Contractor') {
            return '1099'
        }
        if (this.assigned_candidate?.tax_class === 'Employed by GreenLight') {
            return 'W2'
        }
        if (this.assigned_candidate?.can_request_classify_tax) {
            return 'Not Requested'
        }
        return 'Not Selected'
    }

    candidateNeedsGreenlightRequest() {
        return this.assigned_candidate?.needs_request_classify_tax;
    }

    offeringHireType() {
        if (!this.assignedCandidate() || !this.assigned_candidate.job_candidate?.talent_opps?.[0]) {
            return false
        }
        return this.assigned_candidate.job_candidate?.talent_opps?.[0]?.hire_type
    }
    activeDeliverables() {
        if (!this.deliverables?.length) {
            return []
        }
        let deliverables = TB.filter(this.deliverables, ['is_active', true]);
        if (this.assigned_candidate && this.assigned_candidate.job_candidate?.talent_opps?.[0].position_deliverables) {
            deliverables = TB.filter(this.assigned_candidate.job_candidate?.talent_opps?.[0].position_deliverables, del => !!del.target_delivery_at)
        }
        deliverables = TB.filter(deliverables, del => !!del.target_delivery_at)
        deliverables = TB.orderBy(deliverables, del => TB.moment(del.target_delivery_at).valueOf(), 'asc');

        return deliverables;
    }

    hasSchedule() {
        return TB.isArray(this.schedule)
            && this.schedule.length > 0;
    }

    startedAt() {
        let started_at = this.started_at
            ? TB.moment(this.started_at)
            : null;
        if (this.assigned_candidate && this.assigned_candidate.job_candidate?.confirmed_started_at) {
            started_at = TB.moment(this.assigned_candidate.job_candidate?.confirmed_started_at)
        }
        if (this.activeDeliverables()?.length) {
            let deliverables = this.activeDeliverables();
            let first = TB.moment(TB.first(deliverables).target_delivery_at);
            if (!started_at || first.isBefore(started_at)) {
                return first;
            }
        }
        return started_at;
    }

    endedAt() {
        let ended_at = this.ended_at
            ? TB.moment(this.ended_at)
            : null;

        if (this.assigned_candidate && this.assigned_candidate.job_candidate?.confirmed_ended_at) {
            ended_at = TB.moment(this.assigned_candidate.job_candidate?.confirmed_ended_at)
        }
        if (this.activeDeliverables()?.length) {
            let deliverables = this.activeDeliverables();
            if (deliverables.length) {
                let last = TB.moment(TB.last(deliverables).target_delivery_at);
                if (last) {
                    return last
                }
            }
        }

        return ended_at;
    }

    durationInWeeks() {
        let start = this.startedAt(),
            end = this.endedAt();

        if (!start || !end) {
            return;
        }

        return Math.abs(TB.ceil(end.diff(start, 'weeks', true)));
    }

    timeRange(divider = '-') {
        let start = this.startedAt(),
            end = this.endedAt();

        if (!start || !end) {
            return '---';
        }

        return TB.shortTimeRange(start, end, divider);
    }

    weeksUntilStart() {
        let startDate = this.startedAt();
        if (!startDate) {
            return false;
        }

        return startDate.diff(TB.moment(), 'week');
    }

    requiredOnSiteDetails() {
        let details = 'No'
        if (this.required_onsite &&
            !TB.isNaN(parseInt(this.onsite_days_per_week)) &&
            parseInt(this.onsite_days_per_week) > 0
        ) {
            details = `Yes, ${this.onsite_days_per_week} day`;
            if (parseInt(this.onsite_days_per_week) !== 1) {
                details += 's';
            }
            details += ' per week';
        }
        return details;
    }

    estimatedRate() {
        if(this.target_rate) {
            return `${this.targetRate()}/hr`;
        }
        if (this.estimated_rate) {
            return `$${TB.formatNumber(this.estimated_rate - 10,0)}-${TB.formatNumber(this.estimated_rate + 10, 0)}/hr`
        }
        return 'TBD';
    }

    jobInfo = (opportunity = null) => {
        const roundHourlyRate = (rate) => {
            return Math.round((rate + Number.EPSILON) * 100) / 100
        }
        let {
            project,
            disciplines,
            estimated_payout,
            payout_hourly_rate,
            estimated_rate,
            payout_total_periods,
            avg_hours_per_period,
            posted_at,
            total_hours,
            payout_amount
        } = this;


        // if (this.isFixedRetainer() && opportunity.isFixedRetainerCostPerPeriodBased() && !estimated_payout) {
        //     estimated_payout = this.payout_amount;
        // }
        let {
            location
        } = project || {};

        let payoutLabel = "Estimated Payout";

        let payout_rate = parseFloat(payout_hourly_rate || estimated_rate);
        let payout_hours = parseFloat(payout_total_periods || total_hours);
        let hours = parseInt(avg_hours_per_period || total_hours);
        let timeRange = this.timeRange(' - ');

        let hourly_rate_difference = 0;
        let isStandardRate = true;

        if (opportunity) {
            if (opportunity.job_candidate?.estimated_payout_amount) {
                payoutLabel = "Proposed Payout";
                estimated_payout = opportunity.job_candidate?.estimated_payout_amount;
                payout_rate = parseFloat(opportunity.job_candidate?.hourly_rate);
                payout_hours = parseInt(total_hours);
                hourly_rate_difference = opportunity.differenceFromRequestedHourlyRate();
                isStandardRate = !opportunity.hasClientTargetRate()
            }

            timeRange = opportunity.panelTimeDisplay();
            if (this.isFixedFee()) {
                payout_hours = !TB.isNaN(parseInt(opportunity.job_candidate?.total_hours)) ? opportunity.job_candidate?.total_hours : this.total_hours;
            }else {
                hours = !TB.isNaN(parseInt(opportunity.job_candidate?.confirmed_avg_hours_per_period)) ? opportunity.job_candidate?.confirmed_avg_hours_per_period : hours;
            }
        }
        if(this.isFixedRetainer()) {
            let payoutPerPeriod = estimated_payout / this.actual_total_periods;

            return {
                "Contract Type": (<span className="capitalize">{this.contractTypeName()} - {this.payout_frequency}</span>),
                "Location": location?.full,
                [TB.pluralize('Role', disciplines?.length || 1)]: disciplines?.length > 0 && (
                    <span className="flex flex-col items-start gap-2">
                        {TB.map(disciplines, ({id, name}) => (
                            <span key={id}>
                                {name}
                            </span>
                        ))}
                    </span>
                ),
                "Retainer Duration": this.payoutFrequencyLabel(),
                [`Est. Payout per ${this.payout_frequency === 'weekly' ? 'Week' : 'Month'}`]: TB.isDefined(payoutPerPeriod) && TB.formatCurrency(payoutPerPeriod),
                'Total Est. Payout': (
                    <span className="payout">
                        <span>{TB.isDefined(estimated_payout) && TB.formatCurrency(estimated_payout)}</span>
                    </span>
                ),
                "Posted": posted_at && TB.moment(posted_at).fromNow()
            }
        }
        // if(this.isFixedFee()) {
        //     return {
        //         "Contract Type": this.contractTypeName(),
        //         "Location": location?.full,
        //         [TB.pluralize('Role', disciplines?.length || 1)]: disciplines?.length > 0 && (
        //             <span className="flex flex-col items-start gap-2">
        //                 {TB.map(disciplines, ({id, name}) => (
        //                     <span key={id}>
        //                         {name}
        //                     </span>
        //                 ))}
        //             </span>
        //         ),
        //         "Retainer Duration": this.payoutFrequencyLabel(),
        //         [`Est. Payout per ${this.payout_frequency === 'weekly' ? 'Week' : 'Month'}`]: opportunity.job_candidate?.payout_amount || this?.payout_amount,
        //         'Total Est. Payout': (
        //             <span className="payout">
        //                 <span>{TB.isDefined(estimated_payout) && TB.formatCurrency(estimated_payout)}</span>
        //             </span>
        //         )
        //     }
        // }


        let payoutInfo = !TB.auth().user()?.isTalentSupplierResource() ? {
            [payoutLabel]: (
                <span className="payout">
                    <span>
                        {TB.isDefined(estimated_payout) && TB.formatCurrency(estimated_payout)}</span>


                    {this.isTimeMaterials() && !TB.isNaN(roundHourlyRate(payout_rate)) && !TB.isNaN(payout_hours) && (
                        <span className="payout-info">
                            <strong>
                                {`$ ${roundHourlyRate(payout_rate)}`}
                            </strong>
                            {` per hr @ `}
                            <strong>
                                {`${payout_hours} total hours`}
                            </strong>
                        </span>
                    )}

                    {this.isTimeMaterials() && hourly_rate_difference > 0 && (
                        <span className="difference-warning">
                            * Your bill rate is <strong>${hourly_rate_difference} per hour</strong> above
                            the {isStandardRate ? 'Average Bill Rate for this role on Wripple' : 'Client Target Bill Rate for this role'}
                        </span>
                    )}
                </span>
            )
        } : null


        return  {
            "Contract Type": this.contractTypeName(),
            "Location": location?.full,
            [TB.pluralize('Role', disciplines?.length || 1)]: disciplines?.length > 0 && (
                <span className="flex flex-col items-start gap-2">
                    {TB.map(disciplines, ({id, name}) => (
                        <span key={id}>
                            {name}
                        </span>
                    ))}
                </span>
            ),
            "Project Duration": timeRange,
            ...payoutInfo,
            ...(this.isFixedFee() ? {"# of Deliverables" : this.deliverables?.length || 1} : (
                (this.isTimeMaterials()) ? {"Avg Hours Per Week": !TB.isNaN(hours) && TB.pluralize("hr", hours, true)} : {}
            )),
            ...(this.isTimeMaterials() ? {
                "Contract to Hire Interest?": this.is_contract_to_hire ? 'Yes' : 'No',
                "Required On-Site?": this.requiredOnSiteDetails(),
            } : {}),
            "Posted": posted_at && TB.moment(posted_at).fromNow()
        }
    }

    // groupedRequiredSkills()
    // {
    //     return TB.groupBy(
    //         this.skills, 'importance'
    //     );
    // }

    // requiredSkillsOf(importance)
    // {
    //     let skills = this.groupedRequiredSkills()[
    //         importance
    //     ];

    //     if (!TB.isArray(skills)) {
    //         skills = [];
    //     }

    //     return TalentSkill.makeMany(skills);
    // }

    // veryImportantSkillsRequired()
    // {
    //     return this.requiredSkillsOf(
    //         TalentSkill.ImportanceLevels.VeryImportant
    //     );
    // }

    // importantSkillsRequired()
    // {
    //     return this.requiredSkillsOf(
    //         TalentSkill.ImportanceLevels.Important
    //     );
    // }

    // niceToHaveSkillsRequired()
    // {
    //     return this.requiredSkillsOf(
    //         TalentSkill.ImportanceLevels.NiceToHave
    //     );
    // }

    maxSkillsScore()
    {
        return this.maxExpScore('skills');
    }

    maxIndustriesScore() {
        return this.maxAvgExpScore('industries');
    }

    didRequestProposals() {
        return TB.isDefined(this.proposals_requested_at);
    }

    targetRate(formatted = true)
    {
        let rate = this.target_rate;
        if (!this.target_rate_is_visible || !this.target_rate) {
            return false;
        }

        if (!formatted) {
            return rate;
        }

        return TB.formatCurrency(rate);
    }

    marketRate(formatted = true)
    {
        let rate = this.market_rate;

        if (!formatted) {
            return rate;
        }

        return TB.formatCurrency(rate);
    }

    hasBeenFilled() {
        return TB.isObject(this.assigned_candidate);
    }

    currentBriefStep() {
        if (this.hasBeenFilled() || this.total_selected_candidates) {
            return `/shortlist`
        }
        return `/talent-pool/role/${this?.id}`
    }

    assignedCandidate() {
        if (!this.hasBeenFilled()) {
            return;
        }

        return TalentCandidate.make({...this.assigned_candidate});
    }

    preferredTaxClass() {
        if (this.assigned_candidate.needs_request_classify_tax) {
            return "Not Requested"
        }
        switch(this.assigned_candidate?.client_tax_preference) {
            case 'ee-only':
                return "W2"
            case 'ic-only':
                return "1099"
            case 'ic-preferred':
                return "1099 Preferred Otherwise W2"
            case 'any':
                return "No Preference"
            default: return "Not Selected"
        }

    }
    hasCompletedTaxClassificationForCandidate() {
        if (!this.hasBeenFilled() || !this.taxClassification()) {
            return false;
        }
        let candidate = this.assignedCandidate();
        if (candidate.employed_by === 'Wripple') {
            return !!this.latestSignedTalentContract()
        }
        return candidate.tax_classify_status === 'Passed' || candidate.tax_classify_status === 'Not Needed'
    }

    latestSignedTalentContract() {
        if (!this.hasBeenFilled() || !this.taxClassification()) {
            return false;
        }
        let candidate = this.assignedCandidate();

        return candidate?.job_candidate?.latest_signed_contract
    }

    getRoleRequiredSkills(templates = this.templates) {
        console.log('getRoleRequiredSkills', templates)
        if (!templates?.length) return [];

        let requiredSkills = TB.flatMap(templates, 'skills') || [];

        requiredSkills = TB.orderBy(requiredSkills, 'importance', 'desc');

        return TB.uniqBy(requiredSkills, 'id')
    }
    getRoleRequiredDisciplines(templates = this.templates) {
        console.log('getRoleRequiredDisciplines', templates)
        if (!templates?.length) return [];

        let requiredDisciplines = TB.flatMap(templates, 'disciplines') || [];

        // requiredDisciplines = TB.orderBy(requiredDisciplines, 'importance', 'desc');

        return TB.uniqBy(requiredDisciplines, 'id')
    }

    async removeTemplateUpdate(template) {
        let updates = TB.pick(this, ['templates', 'skills', 'disciplines'])

        updates.templates = TB.xorBy(updates.templates, [template], 'id');

        let requiredSkillIds = TB.map(this.getRoleRequiredSkills(updates.templates), 'id');
        let requiredDisciplineIds = TB.map(this.getRoleRequiredDisciplines(updates.templates), 'id');

        let skillsToRemove = TB.filter(template.skills || [], skill => !requiredSkillIds.includes(skill.id))
        let disciplinesToRemove = TB.filter(template.disciplines || [], discipline => !requiredDisciplineIds.includes(discipline.id))

        console.log('removeTemplateUpdate', {disciplines: updates.disciplines, skills: updates.skills,skillsToRemove, disciplinesToRemove})
        if (updates.skills?.length && skillsToRemove.length) {
            updates.skills = TB.differenceBy(updates.skills,skillsToRemove, 'id');
        }
        if (updates.disciplines?.length && disciplinesToRemove.length) {
            updates.disciplines = TB.differenceBy(updates.disciplines,disciplinesToRemove, 'id');
        }

        if ((updates.skills?.length !== this.skills?.length) || (updates.disciplines?.length !== this.disciplines?.length)) {
            let confirm = await TB.alert('confirm', 'Are you sure?',
                'Note: Removing this Wripple Role will also remove the default skills selected for this role. ' +
                'However, you can always add these skills again later if you still need them. Are you sure you want to continue?', [
                    {title: 'Yes, Continue'},
                    {title: 'Cancel'}
                ]
            )

            if (!confirm) return false
        }
        return updates;
    }


    makeNewChangeOrder(type = ProjectPosition.ChangeOrderTypes.TypeTimeline) {

        // console.log('makeNewChangeOrder', original_rate, this.assigned_candidate?.job_candidate?.premarkup_rate)
        // console.log('makeNewChangeOrder', original_rate, this.assigned_candidate?.job_candidate?.premarkup_rate)
        // Current End Date last_segment.ended_at
        // Current Total Hours last_segment.total_hours
        // Tax Classification: last_segment.candidate.tax_type
        // Current Bill Rate last_segment.platform_rate
        // Current Talent Cost Rate last_segment.hourly_rate

        let lastCandidateSegment = TB.last(this.candidate_segments || []);
        if (!lastCandidateSegment) {
            let assignedCandidate = this.assignedCandidate();
            lastCandidateSegment = {
                ended_at: assignedCandidate.ended_at,
                total_periods: assignedCandidate.total_periods,
                candidate: assignedCandidate,
                percent_markup: assignedCandidate.percent_markup,
                platform_rate: assignedCandidate.platform_rate,
                rate: assignedCandidate.rate,
            }
        }

        // items.*.type: Timeline | Rate | Candidate
        // 'items.*.effective_at' => 'required|date',
        // 'items.*.hourly_rate' => 'nullable|numeric|required_if:type,'.ChangeOrderItem::TypeRate,
        // 'items.*.percent_markup' => 'nullable|numeric',
        // 'items.*.ended_at' => 'nullable|date',
        // 'items.*.total_hours' => 'nullable|integer',
        // 'items.*.last_segment_periods' => 'integer|required_if:type,'.ChangeOrderItem::TypeRate.'|required_if:type,'.ChangeOrderItem::TypeCandidate,
        // 'items.*.affected_periods' => 'integer|required_if:type,'.ChangeOrderItem::TypeRate.'|required_if:type,'.ChangeOrderItem::TypeCandidate,
        // 'items.*.new_talent_id' => 'nullable|exists:users,id|required_if:type,'.ChangeOrderItem::TypeCandidate,
        let changeOrder = {
            type,
            effective_at: undefined,
            rate: lastCandidateSegment.rate || lastCandidateSegment.hourly_rate,
            ended_at: lastCandidateSegment.ended_at,
            total_hours: lastCandidateSegment.total_periods || lastCandidateSegment.total_hours,
            total_periods: lastCandidateSegment.total_periods || lastCandidateSegment.total_hours,
            last_segment_periods: lastCandidateSegment.total_periods || lastCandidateSegment.total_hours,
            affected_periods: 0,
            new_talent_id: undefined,
            candidate_segments: [lastCandidateSegment],
            // talent_cost: lastCandidateSegment.talent_cost,
            // platform_fee: lastCandidateSegment.platform_fee,
            platform_rate: lastCandidateSegment.platform_rate,
            percent_markup: lastCandidateSegment.percent_markup
        }

        switch (type) {
            case ProjectPosition.ChangeOrderTypes.TypeTimeline:
                // New End Date: items.*.ended_at
                // New Total Hours: items.*.total_hours
                // changeOrder.ended_at = this.actual_total_periods;
                changeOrder.affected_periods = 0;
                changeOrder.total_periods = lastCandidateSegment.total_periods || lastCandidateSegment.total_hours;
                changeOrder.hour_impact = (lastCandidateSegment.total_periods || lastCandidateSegment.total_hours) - changeOrder.total_periods;
                changeOrder.effective_at = new Date();

                changeOrder.talent_cost = (changeOrder.rate || changeOrder.hourly_rate) * changeOrder.total_periods;
                changeOrder.platform_cost = changeOrder.platform_rate * changeOrder.total_periods;
                changeOrder.platform_fee = changeOrder.platform_cost - changeOrder.talent_cost;
            break;
            case ProjectPosition.ChangeOrderTypes.TypeCandidate:
            case ProjectPosition.ChangeOrderTypes.TypeRate:
                // End Date for Old Rate: items.*.effective_at
                // End Date for New Rate: items.*.ended_at
                // New Talent Cost Rate: items.*.hourly_rate
                // New Bill Rate: (items.*.hourly_rate) * (items.*.percent_markup)
                // Est. Hours at Old Rate : items.*.last_segment_periods
                // Est. Hours at New Rate: items.*.affected_periods


                changeOrder.effective_at = lastCandidateSegment.ended_at;
                changeOrder.platform_rate = lastCandidateSegment.platform_rate;
                changeOrder.percent_markup = lastCandidateSegment.percent_markup;
                changeOrder.hour_impact = (lastCandidateSegment.total_periods - changeOrder.last_segment_periods) + changeOrder.affected_periods;
                    // changeOrder.client_fee_impact = changeOrder.hour_impact;
                    changeOrder.talent_cost = (lastCandidateSegment.rate * changeOrder.last_segment_periods) + (changeOrder.rate * changeOrder.affected_periods);
                    changeOrder.platform_cost = (lastCandidateSegment.platform_rate * changeOrder.last_segment_periods) + (changeOrder.rate * changeOrder.affected_periods);
                    changeOrder.platform_fee = changeOrder.platform_cost - changeOrder.talent_cost;
                break;
                // New Replacement Resource: items.*.new_talent_id
                // End Date for Old Rate: items.*.effective_at
                // End Date for New Rate: items.*.ended_at
                // New Talent Cost Rate: items.*.hourly_rate
                // New Bill Rate: (items.*.hourly_rate) * (items.*.percent_markup)
                // Est. Hours for Prior Talent: items.*.last_segment_periods
                // Est. Hours for New Talent: items.*.affected_periods
                // changeOrder.hourly_rate = original_rate;
                // changeOrder.new_talent_id = undefined;
                // changeOrder.new_total_periods = this.actual_total_periods;
                // changeOrder.affected_periods = this.actual_total_periods;
        }

        return changeOrder;
    }

    /*
   * Source helper methods
   * */
    isHiringSourceTalentPoolReq() {
        return this.source === 'Talent Pool Req'
    }

    isHiringSourceQuickHire() {
        return this.source === 'Browse Talent'
    }

    isHiringSourceWizard() {
        return !this.source || this.source === 'Wizard'
    }
    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */

    static FetchAllTemplatesRequest;
    static FetchTemplateRequest;
    static FetchGreenlightCandidateOptionsRequest;

    static async fetchAllTemplates() {

        if (this.TemplateCached && this.TemplateCached.length) {
            return this.TemplateCached;
        }

        this.FetchAllTemplatesRequest = TB.request(
            TB.api_endpoint('/api/position-templates')
        );

        let response = await this.FetchAllTemplatesRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position_templates')) {
            return false;
        }

        this.TemplateCached = TB.map([...response.success.data.position_templates], template => {
            template.limited = true;

            return template;
        });

        // for (let project of this.Cached) {
        // console.log(project.disciplineHourlyTotals());
        // console.log(project.schedule);
        // }

        return [...this.TemplateCached];
    }

    static async fetchTemplate(templateId) {
        let templates = [];
        if (this.TemplateCached && this.TemplateCached.length) {
            templates = this.TemplateCached;
        } else if (!this.TemplateCached || !this.TemplateCached.length) {
            templates = await this.fetchAllTemplates();
        }


        let template = TB.find(templates, ['id', templateId]);

        if (!template || template.limited) {
            this.FetchTemplateRequest = TB.request(
                TB.api_endpoint(`/api/position-templates/${templateId}`)
            );

            let response = await this.FetchTemplateRequest.post().catch(console.warn);

            if (!TB.has(response, 'success.data.position_template')) {
                return;
            }

            template = {...response.success.data.position_template, limited: false};

            await this.refreshCacheFor(
                template, 'TemplateCached'
            );

            return template;
        } else {
            return template;
        }
    }
    static async fetchDeliverablesForDisciplines(disciplines = [], requestOptions = {}) {

        const fetchDeliverablesRequest = TB.request(
            TB.api_endpoint('/api/deliverables'), {disciplines}
        );

        let response = await fetchDeliverablesRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.deliverables')) {
            throw new Error("Something went wrong")
        }

        return response.success.data.deliverables;
    }

    static async updateContractTerms(projectId, positionId, updateProps)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        if (updateProps.premarkup_rate) {
            updateProps.hourly_rate = updateProps.premarkup_rate;
        }

        let params = TB.pick(updateProps, [
            'hire_type','hourly_rate',
            'exact_platform_rate',
            'confirmed_started_at',
            'percent_markup',
            'confirmed_ended_at',
            'confirmed_avg_hours_per_period',
            'total_hours',
            'total_periods',
            'payout_amount',
        ])
        this.UpdateContractTermsRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/update-contract-terms`),
            params
        );

        let response = await this.UpdateContractTermsRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async updateTalentContract(projectId, positionId, params)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();
        console.log('updateTalentContract', params)

        this.UpdateTalentContractRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/update-assigned-talent-contract`),
            params
        ).headers({
            'Content-Type': 'multipart/form-data'
        });

        let response = await this.UpdateTalentContractRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async generateScopingForDeliverables(projectId, positionId)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();


        this.GenerateScopingRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/estimate-deliverables`)
        );

        let response = await this.GenerateScopingRequest.get().catch(console.warn);

        if (!TB.has(response, 'success.data.deliverables')) {
            throw new Error("Something went wrong");
        }

        return TB.get(response, 'success.data.deliverables') || {};
    }

    static async linkGreenlightJobToCandidate(projectId, positionId, greenlight_job_id)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();
        console.log('updateTalentContract', greenlight_job_id)

        this.LinkGreenLightJobToCandidateRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/greenlight-jobs/link`),
            {greenlight_job_id}
        );

        let response = await this.LinkGreenLightJobToCandidateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async unlinkGreenlightJobToCandidate(projectId, positionId)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        this.UnlinkGreenLightJobToCandidateRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/greenlight-jobs/unlink`)
        );

        let response = await this.UnlinkGreenLightJobToCandidateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async refreshGreenlightStatus(projectId, positionId)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        this.RefreshGreenLightJobRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/greenlight-jobs/linked/refresh`),

        );

        let response = await this.RefreshGreenLightJobRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async fetchGreenlightOptionsForCandidate(projectId, positionId, params = {},requestOptions = {})
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.() || !user.canManageClients?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();
        console.log('fetchGreenlightOptionsForCandidate')

        this.FetchGreenlightCandidateOptionsRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/greenlight-jobs/options`),
            params
        );

        let response = await this.FetchGreenlightCandidateOptionsRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data')) {
            throw new Error("Something went wrong");
        }

        return TB.get(response, 'success.data') || {};
    }

    async terminateCandidateForGreenLight(projectId)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !this.assigned_candidate?.greenlight_id || !user || !user.clientOrg?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        const TerminateCandidateInGreenlightRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${this.id}/greenlight/terminate`),
        );

        let response = await TerminateCandidateInGreenlightRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return ProjectPosition.make(updatedPosition);
    }

    static async requestGreenlightTaxClassVerification(projectId, positionId, updateProps)
    {
        let user = Auth.registeredClientUser();
        if (!projectId || !positionId || !user || !user.clientOrg?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        this.GreenlightTaxClassVerificationRequest = TB.request(
            TB.api_endpoint(`/api/clients/${client.id}/projects/${projectId}/positions/${positionId}/tax-class/request`),
            {...updateProps}
        );

        let response = await this.GreenlightTaxClassVerificationRequest.post().catch(console.warn);

        if (!TB.has(response, 'success.data.position')) {
            throw new Error("Something went wrong");
        }

        let updatedPosition = TB.get(response, 'success.data.position') || {};

        return this.make(updatedPosition);
    }

    static async cancelSearchTemplates()
    {
        if (this.SearchTemplatesRequest && !this.SearchTemplatesRequest.didFinish) {
            await this.SearchTemplatesRequest.cancel();
        }
    }

    static async searchTemplates(tags, requestOptions = {})
    {
        // this.cancelSearchTemplates();
        this.SearchTemplatesRequest = TB.request(
            TB.api_endpoint('/api/position-templates'), {tags}
        );

        let response = await this.SearchTemplatesRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.position_templates')) {
            return false;
        }

        let templates = TB.get(response, 'success.data.position_templates') || [];

        return TB.orderBy(templates, 'tag_score', 'desc');
    }

    static async fetchSharable(project_id, position_id, requestParams = {})
    {
        let user = Auth.registeredClientUser();
        if (!project_id || !position_id || !user || !user.clientOrg?.()) {
            throw new Error("Unauthorized")
        }

        let client = user.clientOrg();

        let SharableForPositionRequest = TB.request(
            TB.api_endpoint(
                `/api/clients/${client.id}/projects/${project_id}/positions/${position_id}/candidates/index-sharable`
            )
        );

        let response = await SharableForPositionRequest.get(requestParams).catch(console.warn);

        await TB.wait(1000);

        if (!response || !TB.has(response, 'success.data.talent_users')) {
            throw new Error(SharableForPositionRequest.didFail ? SharableForPositionRequest.errorMessage() : response)
        }

        let users = TB.get(response, 'success.data.talent_users') || [];

        users = User.makeMany(users);

        return TB.orderBy(users, [
            'is_invited',
            'is_interested',
            'has_confirmed_payout',
            'is_shortlisted',
            'is_favorite',
        ], ['desc', 'desc', 'desc','desc','desc']);
    }

    async setCandidateProfileData(updatedTalent) {
        return TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'fetchTalent' &&
                    parseInt(params.profileId) === updatedTalent.id &&
                    parseInt(params.position) === this.id;
            }
        }, prevData => {

            if (!prevData) {
                return prevData;
            }
            let user = TalentCandidate.make({
                ...TB.cloneDeep(prevData),
                ...TB.cloneDeep(updatedTalent),
                job_candidate: TB.cloneDeep(updatedTalent.job_candidate),
            })
            console.log('updateFetchTalent', user);

            return user;
        })
    }
    async setCandidateMatchesData(updatedTalent, transformPageCallback = (page) => page) {
        return TB.queryClient.setQueriesData({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'positionMatches' && params.project_position === this.id;
            }
            // inactive: false
        }, page => {
            if(!page) return page;
            page.users = TB.map([...page.users], talent => {
                if (talent.id === updatedTalent.id) {
                    return updatedTalent;
                }
                return talent;
            });
            console.log('updatePositionMatches', page.users);

            return transformPageCallback(page);
        });
    }

    async resetCandidateQueryDataForProject(updatedTalent, project = null) {
        if (!updatedTalent) {
            return;
        }

        await this.setCandidateMatchesData(updatedTalent);
        await this.setCandidateProfileData(updatedTalent);

        if (project) {
            await this.refreshInProjectCacheFor(project)
        }
        return updatedTalent
    }

    async resetCandidateQueryDataForTalent(updatedTalent, transformPageCallback = (page) => page) {
        if (!updatedTalent) {
            return;
        }

        await this.setCandidateMatchesData(updatedTalent, transformPageCallback);
        await this.setCandidateProfileData(updatedTalent);

        return updatedTalent
    }
    async resetCandidatesQueryDataForTalent(updatedTalent = [], transformPageCallback = (page) => page) {
        if (!updatedTalent?.length) {
            return;
        }

        TB.queryClient.invalidateQueries({
            predicate: ({queryKey}) => {
                let params = queryKey?.[1] || {};
                return queryKey?.[0] === 'positionMatches' && params.project_position === this.id;
            }
        });
        // TB.queryClient.setQueriesData({
        //     predicate: ({queryKey}) => {
        //         let params = queryKey?.[1] || {};
        //         return queryKey?.[0] === 'positionMatches' && params.project_position === this.id;
        //     }
        //     // inactive: false
        // }, page => {
        //     if(!page) return page;
        //     page.users = TB.map([...page.users], talent => {
        //         if (TB.find(updatedTalent, ['id', talent.id])) {
        //             return TB.find(updatedTalent, ['id', talent.id]);
        //         }
        //         return talent;
        //     });
        //
        //     return transformPageCallback(page);
        // });

        return updatedTalent
    }
}


const requestGreenlightTaxClassVerificationForPosition = async(projectId, positionId, updateProps) => {
    return ProjectPosition.requestGreenlightTaxClassVerification(
        projectId, positionId, updateProps
    );
}

const updateContractTerms = async(projectId, positionId, updateProps) => {
    return ProjectPosition.updateContractTerms(
        projectId, positionId, updateProps
    );
}

const updateTalentContract = async(projectId, positionId, updateProps) => {
    return ProjectPosition.updateTalentContract(
        projectId, positionId, updateProps
    );
}

const generateScopingForDeliverables = async(projectId, positionId) => {
    return ProjectPosition.generateScopingForDeliverables(
        projectId, positionId
    );
}


const linkGreenlightJobToCandidate = async(projectId, positionId, greenlight_job_id) => {
    return ProjectPosition.linkGreenlightJobToCandidate(
        projectId, positionId, greenlight_job_id
    );
}

const unlinkGreenlightJobToCandidate = async(projectId, positionId) => {
    return ProjectPosition.unlinkGreenlightJobToCandidate(
        projectId, positionId
    );
}
const refreshGreenlightStatus = async(projectId, positionId) => {
    return ProjectPosition.refreshGreenlightStatus(
        projectId, positionId
    );
}

const fetchGreenlightOptionsForCandidate = async(projectId, positionId, requestOptions) => {
    return ProjectPosition.fetchGreenlightOptionsForCandidate(
        projectId, positionId, requestOptions
    );
}

export {
    updateContractTerms,
    generateScopingForDeliverables,
    updateTalentContract,
    linkGreenlightJobToCandidate,
    unlinkGreenlightJobToCandidate,
    refreshGreenlightStatus,
    requestGreenlightTaxClassVerificationForPosition,
    fetchGreenlightOptionsForCandidate
}